import Vue from 'vue'
import Vuex from 'vuex'
import image from '../assets/lotus-background.png'
import firstSliderMainPage from './module/firstSliderMainPage'
import featuresStore from "./module/featuresStore";
import MainPageBannerStore from "./module/MainPageBannerStore";
import MainPageOfferStore from "./module/MainPageOfferStore";
import contactInfoStore from "./module/contactInfoStore";
import rentAndBuyStore from "./module/rentAndBuyStore";
import shopsStore from "./module/shopsStore";
import snackBar from "./module/snackBar";
import MainPagePhoto from "./module/MainPagePhoto";
import MainPageUnitsStore from "./module/MainPageUnitsStore";
import Users from "./module/Users";
import cinemaStore from "./module/cinemaStore";
import restaurantStore from "./module/restaurantStore";
import sportStore from "./module/sportStore";
import introduceStore from "./module/introduceStore";
import introduceUnitsAndFeatures from "./module/introduceUnitsAndFeatures";
import entertainmentStore from "./module/entertainmentStore";
import occationalBanner from "./module/occationalBanner";
import {getAuth} from "../api/login";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
   firstSliderMainPage,
    featuresStore,
    shopsStore,
    snackBar,
    MainPageBannerStore,
    MainPageOfferStore,
    contactInfoStore,
    rentAndBuyStore,
    MainPagePhoto,
    MainPageUnitsStore,
    Users,
    cinemaStore,
    restaurantStore,
    sportStore,
    introduceStore,
    introduceUnitsAndFeatures,
    entertainmentStore,
    occationalBanner
  },
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: image,
    drawer: null,
    ruleMainPage :false,
    snackbar: false,
    snackbarText:'',
    isAuth : false,
    loading: false,

  },
  getters:{
    get_is_auth(state){
      return state.isAuth
    },
    get_loading(state){
      return state.loading
    },
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_ACCESS_TOKEN (state,value){
      localStorage.setItem('lotusToken',value)
    },
    SET_REFRESH_TOKEN (state,value){
      localStorage.setItem('refreshToken',value)
    },
    SET_IS_AUTH (state,value){
      state.isAuth = value
    },
    SET_LOADING(state, data){
      state.loading = data;
    },

  },
  actions: {
    async login({ commit },payload) {
      return new Promise((resolve, reject) => {
        getAuth(payload.username , payload.password).then((response)=>{
          commit('SET_ACCESS_TOKEN', response.data.accessToken);
          commit('SET_REFRESH_TOKEN', response.data.refreshToken);

          resolve()
        }).catch((e)=>{
          localStorage.removeItem('lotusToken');
          localStorage.removeItem('refreshToken');
          reject(e)
        });
      })
    },
    setLoading({commit}, val){
      commit('SET_LOADING', val);
    },


  },
})
